export interface NamedItem {
    name: string;
}

export class NamedItemCollection<T extends NamedItem> extends Map<string, T> {

	toArray() {
        return Array.from(this.values());
	}


	/*
	 * Search and return the item with the same Id, but from the collection.
	 * If not found, then we insert the supplied item.
	 * 
	 * This function differs from the C++ code base, because Java is not generic templated,
	 * we cannot do a new T(), so we have to supply a new item in the parameter.
	 */
	// getOrCreate(name: string, item: T) {
	// 	let t = this.get(name);

	// 	if (!t) {
	// 		t = item;
	// 		t.name = name;
	// 		this.set(item.name, item);
	// 	}

	// 	return t;
	// }

	getOrCreate(name: string, c: new () => T) {
		let t = this.get(name);

		if (!t) {
			t = new c();
			t.name = name;
			this.set(t.name, t);
		}

		return t;
	}

	put(item: T) {
		this.set(item.name, item);
		return item;
	}

	create(name: string, c: new () => T) {
		this.delete(name);

		let t = new c();
		t.name = name;
		this.set(t.name, t);

		return t;
	}
}
